import useEventCompetitionCategoryRadiobuttonList from './UseEventCompetitionCategoryRadiobuttonList';

import RadiobuttonList from '../RadiobuttonList';

const EventCompetitionCategoryRadiobuttonList = ({ label, name, isVertical, value, error, message, onChange }) => {
  const { state } = useEventCompetitionCategoryRadiobuttonList();

  return (
    <RadiobuttonList
      label={label}
      name={name}
      isVertical={isVertical}
      items={state.radiobuttonlist}
      value={value}
      error={error}
      message={message}
      onChange={onChange} />
  )
};

export default EventCompetitionCategoryRadiobuttonList;